import "./modal-card-list-block.scss";